import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;
import util from "@/mixins/util";

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            seq: 0,
            name: "",
            files: [],
            detailFiles: [],
            selectArr: [],
            content: '',
            title: '',
            category: '',
            bookFile: [],
            bookList: [],
            stepStatus: 0,
            premium: 0,
            videoFile: [],
            subTitle: '',
            subContent: '',

            stepSeq: 0,
            talkKorean: '',
            talkEnglish: '',
            speakTTSFile: [],
        };
    },
    validators: {
        seq: function (value) {
            return Validator.value(value).regex(
                "^[-+|0-9|]+$",
                "숫자만 입력해주세요."
            );
        },
        files: function (value) {
            return Validator.value(value).custom(() => {
                if (value.length === 0) {
                    return "이미지를 선택해주세요.";
                }

            });
        },
        detailFiles: function (value) {
            return Validator.value(value).custom(() => {
                if (value.length === 0) {
                    return "이미지를 선택해주세요.";
                }

            });
        },
        name: function (value) {
            return Validator.value(value).required("카테고리명을 입력해주세요.");
        },
        selectArr: function (value) {
            return Validator.value(value);
        },
        title: function (value) {
            return Validator.value(value)
                .required("제목을 입력해주세요.");
        },
        content: function (value) {
            return Validator.value(value)
                .required("내용을 입력해주세요.");
        },
        category: function (value) {
            return Validator.value(value)
                .required("카테고리를 선태해주세요.");
        },
        bookFile: function (value) {
            return Validator.value(value);
        },
        stepStatus: function (value) {
            return Validator.value(value);
        },
        subTitle: function (value) {
            return Validator.value(value);
        },
        subContent: function (value) {
            return Validator.value(value)

        },
        premium: function (value) {
            return Validator.value(value);
        },
        videoFile: function (value) {
            return Validator.value(value).custom(() => {
                if (value.length === 0) {
                    return "영상을 선택해주세요.";
                }
            });
        },

        stepSeq: function (value) {
            return Validator.value(value)
                .required('노출순서를 입력하세요.')
                .regex("^[-+|0-9|]+$", "숫자만 입력해주세요.");
        },
        talkKorean: function (value) {
            return Validator.value(value)
                .required('한국어 말하기 문구를 입력하세요.')
        },
        talkEnglish: function (value) {
            return Validator.value(value)
        },

    },
    methods: {},
    computed: {},
};
